<script>
import { EventBus } from '@/helpers/eventBus'
import { fieldValidationsMixin } from '@/mixins/fieldValidationsMixin'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin, fieldValidationsMixin],
  validations: {
    roleName: {
      required,
      minLength: minLength(3)
    }
  },
  data() {
    return {
      dialog: false,
      roleName: '',
      notification: {
        state: true,
        message: '',
        type: 'success'
      }
    }
  },
  methods: {
    //create a new Role
    async createRole() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        await this.$backofficeService
          .createRole({ roleName: this.roleName })
          .then(() => {
            this.notification.message =
              this.$t('component.backoffice.rolesAddDialog.role') +
              this.roleName + this.$t('component.backoffice.rolesAddDialog.role.added')
            this.notification.type = 'success'
          })
          .catch(() => {
            this.notification.message =
              this.$t('component.backoffice.rolesAddDialog.role') +
              this.roleName +
              this.$t('component.backoffice.rolesAddDialog.add.role.error')
            this.notification.type = 'error'
          })
          .finally(() => {
            this.dialog = false
            this.notification.state = true
            EventBus.$emit('backoffice_notification', this.notification)
            this.$emit('saved')
          })
      }
    }
  }
}
</script>
<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <template #activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on">
        <v-icon>mdi-plus</v-icon>
        {{$t('component.backoffice.rolesAddDialog.role')}}
      </v-btn>
    </template>
    <v-card>
      <DialogBaseColoredTitle color="primary">{{$t('component.backoffice.rolesAddDialog.add.role')}}</DialogBaseColoredTitle>
      <v-divider></v-divider>
      <DialogBaseText>
        <v-text-field
          id="rolesAddRoleName"
          v-model="roleName"
          :label="$t('component.backoffice.rolesAddDialog.role')"
          :error-messages="[
            ...fieldNeccessary($v.roleName, $v),
            ...minLength($v.roleName, $v)
          ]"
          outlined
          dense
          required
        />
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn color="secondary" @click="dialog = false">{{$t('button.cancel')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="createRole">{{$t('button.save')}}</v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
